module.exports = __webpack_public_path__ + "img/logo.e1df7778.svg";